// DFW Cities Configuration for Local SEO
export interface DFWCity {
  name: string;
  slug: string;
  state: "TX";
  description: string;
  neighborhoods?: string[];
  zipCodes?: string[];
  population?: string;
  highlights: string[];
}

export const DFW_METRO = {
  name: "Dallas–Fort Worth",
  shortName: "DFW",
  region: "North Texas",
  tagline: "Proudly serving Dallas–Fort Worth homeowners since 2015",
};

export const DFW_CITIES: DFWCity[] = [
  {
    name: "Dallas",
    slug: "dallas",
    state: "TX",
    description: "As the heart of North Texas, Dallas homeowners know the value of a premium backyard retreat. Our showroom in nearby Carrollton makes it easy for Dallas residents to experience our hot tubs in person before buying.",
    neighborhoods: ["Highland Park", "University Park", "Preston Hollow", "Lake Highlands", "Oak Lawn", "Uptown"],
    highlights: ["Same-day delivery available", "15 minutes from downtown", "Local installation experts"],
  },
  {
    name: "Fort Worth",
    slug: "fort-worth",
    state: "TX",
    description: "Fort Worth's spacious backyards and family-friendly lifestyle make it perfect for hot tub ownership. We deliver and install throughout Fort Worth and the surrounding Tarrant County area.",
    neighborhoods: ["Southlake", "Keller", "Colleyville", "Westover Hills", "Rivercrest"],
    highlights: ["Serving all of Tarrant County", "White-glove delivery", "Texas-owned business"],
  },
  {
    name: "Plano",
    slug: "plano",
    state: "TX",
    description: "Plano residents enjoy some of the finest outdoor living spaces in North Texas. Our Carrollton showroom is just minutes away, making it convenient for Plano homeowners to browse our premium hot tub selection.",
    neighborhoods: ["West Plano", "Legacy", "Willow Bend", "Preston Hollow"],
    highlights: ["10-minute drive from showroom", "Popular with Plano families", "Quick delivery turnaround"],
  },
  {
    name: "Frisco",
    slug: "frisco",
    state: "TX",
    description: "Frisco's rapidly growing communities feature beautiful new homes with spacious backyards perfect for hot tubs. We're the preferred hot tub dealer for Frisco's discerning homeowners.",
    neighborhoods: ["Starwood", "Newman Village", "Phillips Creek", "Stonebriar"],
    highlights: ["New construction specialists", "Same-week installation", "Frisco's top-rated dealer"],
  },
  {
    name: "McKinney",
    slug: "mckinney",
    state: "TX",
    description: "McKinney's historic charm and growing suburban communities create the perfect backdrop for backyard relaxation. We proudly serve McKinney with premium hot tubs at factory-direct prices.",
    neighborhoods: ["Stonebridge Ranch", "Craig Ranch", "Adriatica", "Trinity Falls"],
    highlights: ["Historic downtown nearby", "Growing community", "Family-owned service"],
  },
  {
    name: "Allen",
    slug: "allen",
    state: "TX",
    description: "Allen homeowners appreciate quality and value. Our factory-direct pricing means Allen residents can enjoy luxury hot tubs without luxury price tags.",
    neighborhoods: ["Twin Creeks", "Montgomery Farm", "The Courses"],
    highlights: ["Quick delivery from Carrollton", "Competitive pricing", "Local expertise"],
  },
  {
    name: "Carrollton",
    slug: "carrollton",
    state: "TX",
    description: "Visit our showroom right here in Carrollton! As our home base, Carrollton residents enjoy the easiest access to our full selection of hot tubs, plus exclusive local deals.",
    neighborhoods: ["Castle Hills", "Indian Creek", "Hebron"],
    highlights: ["Showroom located here!", "Walk-in welcome", "Best local deals"],
  },
  {
    name: "Irving",
    slug: "irving",
    state: "TX",
    description: "Irving's diverse communities deserve premium outdoor living. From Las Colinas to Valley Ranch, we deliver and install hot tubs throughout Irving.",
    neighborhoods: ["Las Colinas", "Valley Ranch", "Lake Carolyn"],
    highlights: ["Las Colinas specialists", "Quick turnaround", "Professional installation"],
  },
  {
    name: "Grapevine",
    slug: "grapevine",
    state: "TX",
    description: "Grapevine's wine country lifestyle pairs perfectly with backyard hot tub relaxation. Enjoy the best of Texas outdoor living with our premium selection.",
    neighborhoods: ["Grapevine Lake", "Historic Main Street", "Southlake border"],
    highlights: ["Wine country living", "Lake community experts", "Premium installations"],
  },
  {
    name: "Southlake",
    slug: "southlake",
    state: "TX",
    description: "Southlake's luxury homes deserve luxury hot tubs. We specialize in premium installations for Southlake's discerning homeowners who expect the best.",
    neighborhoods: ["Southlake Town Square", "Timarron", "Shady Oaks"],
    highlights: ["Luxury home specialists", "Premium Cal Spas dealer", "White-glove service"],
  },
  {
    name: "Arlington",
    slug: "arlington",
    state: "TX",
    description: "Arlington homeowners, from entertainment district to suburban neighborhoods, trust us for quality hot tubs at unbeatable prices.",
    neighborhoods: ["Entertainment District", "Pantego", "Dalworthington Gardens"],
    highlights: ["Tarrant County coverage", "Family-friendly options", "Flexible financing"],
  },
  {
    name: "Flower Mound",
    slug: "flower-mound",
    state: "TX",
    description: "Flower Mound's beautiful master-planned communities feature stunning backyards perfect for hot tub installation. We're your local DFW dealer.",
    neighborhoods: ["Bridlewood", "Wellington", "Canyon Falls"],
    highlights: ["Master-planned community experts", "Quick delivery", "Premium options"],
  },
  {
    name: "Lewisville",
    slug: "lewisville",
    state: "TX",
    description: "Lewisville lake living meets backyard luxury. Our Carrollton showroom is just minutes away for Lewisville residents ready to upgrade their outdoor space.",
    neighborhoods: ["Castle Hills", "Lake Lewisville", "Vista Ridge"],
    highlights: ["Lake community focus", "Close to showroom", "Waterfront installations"],
  },
  {
    name: "Richardson",
    slug: "richardson",
    state: "TX",
    description: "Richardson's established neighborhoods and tech-forward residents appreciate our quality hot tubs and professional installation services.",
    neighborhoods: ["Canyon Creek", "Breckinridge Park", "Telecom Corridor"],
    highlights: ["Established community", "Professional service", "Quality focus"],
  },
  {
    name: "The Colony",
    slug: "the-colony",
    state: "TX",
    description: "The Colony's lakeside living deserves premium outdoor amenities. We provide hot tubs that complement your waterfront lifestyle.",
    neighborhoods: ["Tribute", "Stewart Creek", "Grandscape area"],
    highlights: ["Lakeside specialists", "Modern installations", "Grandscape neighbor"],
  },
  {
    name: "Prosper",
    slug: "prosper",
    state: "TX",
    description: "Prosper's luxury new-build homes feature expansive outdoor living spaces. We help Prosper homeowners complete their dream backyards.",
    neighborhoods: ["Windsong Ranch", "Whitley Place", "Star Trail"],
    highlights: ["New construction focus", "Luxury home fit", "Growing community"],
  },
  {
    name: "Celina",
    slug: "celina",
    state: "TX",
    description: "Celina's rapidly growing community attracts families seeking the best in outdoor living. We're proud to serve Celina's new homeowners.",
    neighborhoods: ["Light Farms", "Mustang Lakes", "Cambridge Crossing"],
    highlights: ["Fast-growing area", "New home specialists", "Future-ready"],
  },
];

export const getCity = (slug: string): DFWCity | undefined => {
  return DFW_CITIES.find((city) => city.slug === slug);
};

export const getCityNames = (): string[] => {
  return DFW_CITIES.map((city) => city.name);
};

export const formatCityState = (city: DFWCity): string => {
  return `${city.name}, ${city.state}`;
};
